export const DEFAULT_ANNOTATION_COLOR = '#33C9FF';

export const ANNOTATION_COLOR_PRESETS = [
  DEFAULT_ANNOTATION_COLOR,
  '#7CFF48',
  '#FFE24A',
  '#FF5FD2',
  '#FF8A3D',
  '#9A7CFF',
];

export const LAST_ANNOTATION_COLOR_KEY = 'last_annotation_color';
